document.addEventListener('DOMContentLoaded', function() {
  const wagerElements = document.querySelectorAll('.wager-value');

  // Add a click event listener to each element
  wagerElements.forEach(wagerElement => {
    wagerElement.addEventListener('click', function() {
      // Toggle the 'selected' class on click
      this.classList.toggle('selected');

      // Force repaint for Safari
      this.style.display = 'none';
      this.offsetHeight; // Trigger a reflow
      this.style.display = 'inline-block';
    });
  });

  // Reset styles when navigating back to the page
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      // If the page was loaded from the cache
      wagerElements.forEach(wagerElement => {
        wagerElement.classList.remove('selected'); // Remove 'selected' class
      });
    }
  });
});
